import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import PageTitleSection from "../Components/PageTitleSection";
import FooterSection from "../Components/FooterSection";
import Spacer from "../Components/Spacer";
import SliderMain from "react-slick";
import HttpHelper from '../service/httpService'
import { handleImageError } from "../base/Utility";

const Location = (props) => {
    const [locations, setLocations] = useState([]);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToScroll: 1,
    };
    const getLocations = async () => {
        await HttpHelper.get("website/GetLocations").then((response) => {
            if (response.status === 200) {
                setLocations(response.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    useEffect(() => {
        getLocations();
    }, [])

    return (<>
        <Header />
        <PageTitleSection
            title="Our Multiple Locations"
            pagetitle="Location"
            subtitle=""
            bgImage="assets/images/pages/services.jfif"
        />

        <section className="section sliderLocation blackBg">
            <div className="container">
                <div className="row">
                    <SliderMain {...settings}>
                        {
                            locations.length > 0 ? locations.map((location, index) => {
                                return (<div className="swiper-slide" key={index}>

                                    <div className="locationContainer pt-0">
                                        <h3>{location.heading}</h3>
                                        <h6>{location.subHeading}</h6>
                                        <p className="scrollbar-thin" style={{ overflowY: 'auto', height: '150px' }}>
                                            <div dangerouslySetInnerHTML={{ __html: location.content }}></div>
                                        </p>
                                    </div>
                                    {location.file ? <div className="locationImg">
                                        <img src={location.file.fileUrl} onError={handleImageError} />
                                    </div> : ''}

                                </div>)
                            }) : null
                        }
                    </SliderMain>
                </div>
            </div>
        </section>
        <Spacer bgClass="blackBg" />
        <FooterSection />
    </>)
}

export default Location;